import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Template from "@/services/template/template";

export function useDeleteTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const result = await Template.deleteTemplate(id);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to delete template");
      }
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["templates"] });
    },
  });
}
